import { UPDATE_TRIGGERS } from './constants';

export function updateTrigger(states) {
  return {
    type: UPDATE_TRIGGERS,
    states,
  };
}
